import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_6: FaireProductEntity = {
  token: "caden-lane-6",
  type: "product",
  name: "Sweet Like Candy Zipper Footie | Blue",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/53d26baabce3abb67d6a88727d2c28ba666e9133790a57e72670b4216bea3480.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
